import { render, staticRenderFns } from "./estado_declaracion_completo.vue?vue&type=template&id=7046d063"
import script from "./estado_declaracion_completo?vue&type=script&lang=js&external"
export * from "./estado_declaracion_completo?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports